canvas{image-rendering:pixelated}svg{width:100%;height:100%}
/*# sourceMappingURL=image-overlay-data.component.css.map */
